module.exports = __webpack_public_path__ + "assets/030510b2e63311726e2c3fc1e7917856.svg";